export default "__VITE_ASSET__DWOYl3OL__"